import React from "react";

const PlaneTask = ({ style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36" }) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            fill={fill}
            d="M30.526 23.188v9.225A1.58 1.58 0 0 1 28.95 34H3.574C2.704 34 2 33.282 2 32.388V13.2h9.508c.876 0 1.585-.716 1.585-1.6V2h15.85c.874 0 1.583.728 1.583 1.587v6.025L16.265 24.01l-.01 6.782 6.73.01 7.54-7.614Zm1.233-10.296L34 15.155 21.674 27.6l-2.245-.003.003-2.26L31.76 12.892ZM2 10l7.924-7.995V10H2Z"
        />
    </svg>
);

export default PlaneTask;